var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel", class: { "panel-with-footer": !_vm.isLoading } },
    [
      _vm.isLoading
        ? _c("div", [
            _c(
              "div",
              { staticClass: "px-5 pb-5" },
              [_c("news-loading-skeleton")],
              1
            )
          ])
        : _c("div", [
            _c("div", { staticClass: "panel-body-lg" }, [
              _c("div", { staticClass: "pb-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column flex-lg-row justify-content-lg-between"
                  },
                  [
                    _c("h2", [_vm._v("Top stories at Autodesk")]),
                    _vm._v(" "),
                    _c("summarize-news-button", { key: _vm.$route.fullPath })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.isErrored
                ? _c("div", { staticClass: "alert alert-error" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.CONSTANTS.SERVER_ERROR_MESSAGE) +
                        "\n      "
                    )
                  ])
                : _c("div", [
                    _vm.posts && _vm.posts.length > 0
                      ? _c("div", [
                          _vm.featuredPost
                            ? _c(
                                "div",
                                [
                                  _c("news-card-featured", {
                                    attrs: { "post-data": _vm.featuredPost }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.posts
                            ? _c(
                                "div",
                                {
                                  staticClass: "row pr-lg-5 pb-3 pt-4 pt-md-1"
                                },
                                _vm._l(_vm.posts, function(post) {
                                  return _c(
                                    "div",
                                    {
                                      key: post.hitId,
                                      staticClass: "col-12 col-xl-6"
                                    },
                                    [
                                      _c("news-card", {
                                        staticClass: "pr-lg-3 pb-4",
                                        attrs: { "post-data": post }
                                      })
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ])
                      : _c("div", { staticClass: "pb-5" }, [
                          _vm._v("No top stories to display")
                        ])
                  ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "panel-footer-wrapper" },
              [
                _c("panel-footer", {
                  attrs: {
                    text: "View all stories",
                    "router-link-to": { path: "news" },
                    "event-name": "Top stories panel view all clicked"
                  }
                })
              ],
              1
            )
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e5ddfae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e5ddfae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/news/TopStoriesPanel.vue
// module id = null
// module chunks = 